const LineGradient = ({ value }) => {
  return <div className={`h-0.5 ${value} `} />;
};

export default LineGradient;
